module.exports = __webpack_public_path__ + "img/footer_bottom_separate.365eb12b.svg";